import { ImageName } from "@mcleod/images";
import { ComponentDemoDefinition } from "./ComponentDemoDefinition";
import { DemoRegistry } from "../DemoRegistry";

export class ComponentDemoFactory {
    registerComponentDemos() {
        const registry = DemoRegistry.get();
        registry.register(new ComponentDemoDefinition("Button","button/Button", ImageName.designer_button));
        registry.register(new ComponentDemoDefinition("Checkbox", "checkbox/Checkbox", ImageName.designer_checkbox));
        registry.register(new ComponentDemoDefinition("Image", "image/Image", ImageName.designer_image));
        registry.register(new ComponentDemoDefinition("Label", "label/Label", ImageName.designer_label));
        registry.register(new ComponentDemoDefinition("List", "list/List", ImageName.list));
        registry.register(new ComponentDemoDefinition("Layout", "layout/Layout", ImageName.designer_layout));
        registry.register(new ComponentDemoDefinition("Panel", "panel/Panel", ImageName.designer_panel));
        registry.register(new ComponentDemoDefinition("RadioBox", "radio/RadioBox", ImageName.designer_radiobox));
        registry.register(new ComponentDemoDefinition("RadioButtonGroup", "radio/RadioButtonGroup", ImageName.designer_radio));
        registry.register(new ComponentDemoDefinition("Stepper", "stepper/Stepper", ImageName.designer_stepper));
        registry.register(new ComponentDemoDefinition("Switch", "switch/Switch", ImageName.designer_switch));
        registry.register(new ComponentDemoDefinition("Table", "table/Table", ImageName.designer_table));
        registry.register(new ComponentDemoDefinition("Tabset", "tabset/Tabset", ImageName.designer_tabset));
        registry.register(new ComponentDemoDefinition("Textbox", "textbox/Textbox", ImageName.designer_textbox));
        registry.register(new ComponentDemoDefinition("Tree", "tree/Tree", ImageName.designer_tree));
    }
}
